import { encodePeriodValue } from '@components'

import { useState } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { PeriodMode } from '../../../enums/periodMode'
import { PeriodValue } from '../../../types/periodValue'

const defaultPeriod: PeriodValue = {
  mode: PeriodMode.All,
}

export const useExportsPeriodValue = () => {
  const [period, setPeriod] = useState<PeriodValue>(defaultPeriod)
  const { organization } = useUserOrganization()
  const organizationId = organization?.id

  const encodedPeriodValue = organizationId && encodePeriodValue(period, organizationId)

  return { encodedPeriodValue, period, setPeriod }
}
